import React from "react";
import { SettingsPage } from "./SettingsPage";
import { SettingsProvider } from "./context/SettingsContext";

const Settings = () => {
	return (
		<SettingsProvider>
			<SettingsPage />
		</SettingsProvider>
	);
};

export default Settings;
